import { render } from "./my-edit-dialog.vue?vue&type=template&id=861d5a46"
import script from "./my-edit-dialog.vue?vue&type=script&lang=js"
export * from "./my-edit-dialog.vue?vue&type=script&lang=js"

import exportComponent from "../../../accutrax-front/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__